import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_3 = { class: "mt-0 lg:mt-4 flex items-baseline text-gray-900" }
const _hoisted_4 = { class: "text-5xl font-extrabold tracking-tight" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-xl font-semibold text-gray-900" }, "/Month", -1)
const _hoisted_6 = {
  role: "list",
  class: "mt-0 lg:mt-4 mb-2 space-y-6"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "text-gray-500" }
const _hoisted_9 = ["href"]

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '../../services/utilityServiceInterface';

import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isSelectedProduct: { type: Boolean, required: true },
    product: { type: Object, required: true }
  },
  emits: ["handle-select-product"],
  setup(__props: any, { emit }: { emit: ({(event: 'handle-select-product', product: Product): void}), expose: any, slots: any, attrs: any }) {

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');





const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const standardLinks: Array<{ name: string, link: string }> = [{
  name: 'Critical Information Summary',
  link: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${brandService.getName()}/critical-information-summary-phone.pdf`
}];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectProduct(__props.product))),
    class: _normalizeClass(["my-2 lg:my-0 cursor-pointer transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col border", [__props.isSelectedProduct ? 'border-black' : 'border-gray-200']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, "Talk " + _toDisplayString(_unref(utilityService).toTitleCase(__props.product.name)), 1),
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "$" + _toDisplayString(__props.product.price), 1),
        _hoisted_5
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(__props.product.description), 1)
        ])
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(standardLinks, (standardLink) => {
        return _createElementVNode("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href text-blue-500 hover:text-blue-800 hover:underline transition duration-250 my-3"
        }, _toDisplayString(standardLink.name), 9, _hoisted_9)
      }), 64))
    ]),
    _createElementVNode("button", {
      class: _normalizeClass([('mt-0 lg:mt-3 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium text-brand-secondary text-brand-secondary'), (__props.isSelectedProduct ? 'bg-brand-primary' : 'bg-brand-primary-light hover:bg-brand-primary')])
    }, _toDisplayString(__props.isSelectedProduct ? 'Selected' : 'Select Product'), 3)
  ], 2))
}
}

})